module.exports = __webpack_public_path__ + "static/media/cover.bad3e1ae.png";